'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRoot = function getRoot(state) {
  return state.oauth;
};

var getGoogleOAuthVerifyRequestState = exports.getGoogleOAuthVerifyRequestState = function getGoogleOAuthVerifyRequestState(state) {
  return getRoot(state).get('googleOAuthRequestState');
};
var getIdToken = exports.getIdToken = function getIdToken(state) {
  return getRoot(state).get('idToken');
};